import { Component, OnInit } from '@angular/core';

import { SettingService } from 'src/app/services/setting.service';

@Component({
    selector: 'app-account-settings',
    templateUrl: './account-settings.component.html',
    styles: [],
    standalone: false
})
export class AccountSettingsComponent implements OnInit {

  constructor( private settingsServices: SettingService ) { }

  ngOnInit(): void {
    this.settingsServices.checkCurrentTheme();
  }

  changeTheme(theme: string) {
   this.settingsServices.changeTheme(theme);
  }
}
